// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__ev1kP","suggestion":"Main_suggestion__6lQGX"};